import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=e5d3b71a&scoped=true&"
import script from "./AdminCategories.vue?vue&type=script&lang=js&"
export * from "./AdminCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategories.vue?vue&type=style&index=0&id=e5d3b71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d3b71a",
  null
  
)

export default component.exports